export default __webpack_public_path__ + "static/media/searchIcon.f12324e8.svg";